import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchData } from './config/dataSlice';
import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProjectsPage from './pages/ProjectsPage';
import ErrorPage from './pages/ErrorPage';

const Container = ({component}) => {
    return(
        <>
            <Navbar />
            {component}
            <Footer />
        </>
    )
}

const App = (props) => {
    const dispatch = useDispatch();
    const status = useSelector((state) => state.data.status);
    const error = useSelector((state) => state.data.error);

    useEffect(() => {
        if (status === 'idle') {
            dispatch(fetchData());
        }
    }, [status, dispatch]);

    const router = createBrowserRouter([
        {
            path: "/",
            element: <Container component={<HomePage />} />,
        },
        {
            path: "/about",
            element: <Container component={<AboutPage />} />,
        },
        {
            path: "/projects",
            element: <Container component={<ProjectsPage />} />,
        },
        {
            path: "/*",
            element: <ErrorPage />,
        },
    ]);

    let content;

    if (status === 'loading') {
        content = <div className='h-screen w-screen flex justify-center items-center txt'>Loading...</div>;
    } else if (status === 'succeeded') {
        content = <RouterProvider router={router} />;
    } else if (status === 'failed') {
        content = <div className='h-screen w-screen flex justify-center items-center txt'>{error}</div>;
    }
  
    return content;
}


export default App;